export const addSortAndFilterParams = (
  search: string | undefined | null,
  order_by: string | undefined | null,
  sort_direction: string | undefined | null,
  otherParams: Record<string, string | number>,
) => {
  if (search) {
    otherParams.search = search;
  }

  if (order_by) {
    otherParams.order_by = order_by;
  }

  if (sort_direction) {
    otherParams.sort_direction = sort_direction;
  }

  return otherParams;
};
